module.exports = __webpack_public_path__ + "img/tubiao-38.bd07ff08.png";